import { countUp } from './count';

const duration = 1200;

document.addEventListener('DOMContentLoaded', () => {
const targets = document.querySelectorAll('[data-animation-area]');

  if(targets.length){
    const options = {
      root: null, // ビューポートを基準
      rootMargin: '0px 0px -20% 0px', // 下に20%のマージンを設定（上から80%の位置）
      threshold: 0 // 交差が少しでもあればコールバック
    };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const targetItems = entry.target.querySelectorAll('[data-animation-item]');

          targetItems.forEach(targetItem => {
            const delay = Number(targetItem.getAttribute('data-delay')) || 0;
            setTimeout(() => {
              targetItem.classList.add('is-inview');

              // data-count 属性がある場合は countUp 関数を実行
              const count = targetItem.getAttribute('data-count');
              if (count) {
                countUp(targetItem, 0, Number(count), duration);
              }
            }, delay);
          });
          observer.unobserve(entry.target); // 一度クラスを追加したら監視を停止
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    targets.forEach(target => {
      observer.observe(target);
    });

    window.addEventListener('load', () => {
      // Intersection Observerは通常、初回に既に交差している要素を検出しますが、
      // 万が一検出されない場合のためのフォールバック
      targets.forEach(target => {
        if (target.classList.contains('is-inview')) return; // 既にクラスが付与されている場合はスキップ
        const rect = target.getBoundingClientRect();
        const triggerPoint = window.innerHeight * 0.8;
        if (rect.top <= triggerPoint) {
          const targetItems = target.querySelectorAll('[data-animation-item]');

          targetItems.forEach(targetItem => {
            const delay = Number(targetItem.getAttribute('data-delay')) || 0;
            setTimeout(() => {
              targetItem.classList.add('is-inview');

              // data-count 属性がある場合は countUp 関数を実行
              // const count = targetItem.getAttribute('data-count');
              // if (count) {
              //   countUp(targetItem, 0, Number(count), duration);
              // }
            }, delay);
          });

          observer.unobserve(target);
        }
      });
    });
  }

});